/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Try_Magic_SubtitleInputs */

const en_try_magic_subtitle = /** @type {(inputs: Try_Magic_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"I couldn't believe this is A.I. generated!" -- Does it sound like a real person? Give it a try!`)
};

const es_try_magic_subtitle = /** @type {(inputs: Try_Magic_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"¡No podía creer que esto es generado por I.A.!" -- ¿Suena como una persona real? ¡Pruébalo!`)
};

/**
* | output |
* | --- |
* | "\"I couldn't believe this is A.I. generated!\" -- Does it sound like a real person? Give it a try!" |
*
* @param {Try_Magic_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const try_magic_subtitle = /** @type {((inputs?: Try_Magic_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Try_Magic_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_try_magic_subtitle(inputs)
	return en_try_magic_subtitle(inputs)
});